import BlockUtilsMixin from '@intercom/embercom-composer/components/mixins/block-utils';
import { next } from '@ember/runloop';
import Em from 'ember';
export default Em.Mixin.create(BlockUtilsMixin, {
  focusIn() {
    try {
      this.setLastActiveBlockAndSelection();
      if (this.get('composerState.selection.isAtZero')) {
        // When tabbing in on Firefox selection does not get set correctly
        next(this, function () {
          let domSelection = this.get('uiSelection.domSelection');
          if (domSelection && domSelection.isComposerAnchorNode()) {
            this.updateDomAndSelection();
          }
        });
      }
      this.setSelectionCoordinates();
    } catch (error) {
      this.sendError(error);
    }
  },
  focusOut() {
    this.checkForContent();
  }
});